import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import type { ClaimMarkerScheme } from "@patent-studio/api-types";
import { CLAIM_PREFERENCES_KEY } from "@/hooks/query-keys";
import { MUTATION_KEYS } from "@/lib/analytics/mutation-reporting";
import {
  chooseClaimPreferences,
  readClaimPreferences,
} from "@/services/preferences";

/** The lettering the signed-in attorney's new drafts start in. */
export function useClaimPreferences() {
  return useQuery({
    queryKey: CLAIM_PREFERENCES_KEY,
    queryFn: readClaimPreferences,
  });
}

/**
 * Make a lettering the one new drafts start in. The answer is the stored choice,
 * so it is written into the cache rather than read again.
 */
export function useChooseClaimPreferences() {
  const client = useQueryClient();
  return useMutation({
    mutationKey: MUTATION_KEYS.claimPreferences,
    mutationFn: (scheme: ClaimMarkerScheme) => chooseClaimPreferences(scheme),
    onSuccess: (stored) => {
      client.setQueryData(CLAIM_PREFERENCES_KEY, stored);
    },
  });
}
